<template>
    <div :key="has_role">
        <div v-if="loading" class="text-center">
            <slot name="loading"><b-spinner></b-spinner></slot>
        </div>
        <slot v-else-if="has_role"></slot>
        <slot
            v-else-if="!authorized"
            name="not-authorized"
        >
            <h1>Not authorized</h1>
        </slot>
        <slot v-else name="no-role"></slot>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: {
        role: String
    },
    data() {
        return {
            authorized: true
        };
    },
    computed: {
        has_role() {
            return this.cached_roles[this.role];
        },
        ...mapState(["cached_roles", "loading"])
    }
}
</script>